export default __webpack_public_path__ + "static/media/Group9247.5cbaa174.svg";